<div class="popup-container">
    <div class="header text-middle roboto-medium">
        AET Event Deletion History
    </div>
    <app-notification-message [errorMessage]="errorMessage" [successMessage]="successMessage">
    </app-notification-message>
    <div class="grid-agg">

        <ag-grid-angular class="ag-theme-balham grid-items viewEventDele" [rowData]="rowData" (gridReady)="onGridReady($event);"
            (window:resize)="sizeToFit()" [animateRows]="true" [defaultColDef]="defaultColDef" [columnDefs]="columnDefs"
            [suppressCellFocus]="true" [headerHeight]="40" [floatingFiltersHeight]="40" [icons]="icons"
            [pagination]="true" [paginationPageSize]="paginationPageSize" [suppressPaginationPanel]="true"
            (paginationChanged)="onPaginationChanged()" [rowClassRules]="rowClassRules" [theme]="'legacy'">
        </ag-grid-angular>

        <div class="d-flex pagination align-items-center justify-content-between mt-1">
            <div>
                <div>
                    <label class="page-drpdwn-label mx-2">Records/Page: </label>
                    <select (change)="onPageSizeChanged($event)" class="paginate_drpdwn">
                        <option value="5">5</option>
                        <option value="10" selected>10</option>
                        <option value="20">20</option>
                        <option value="50">50</option>
                        <option value={{rowCount1}}>ALL</option>
                    </select>
                </div>
            </div>
            <div class="d-flex align-items-center gap-3">
                <div>Viewing Records</div>
                <img src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToFirstPage()"
                    class="text-primary reverse firstPage"
                    [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
    
                <img src="assets/images/Icon metro-next.svg" (click)="goToPreviousPage()"
                    class="text-primary reverse previousPage"
                    [ngClass]="{'disable_icon':getCurrentPage()== true,'enable_icon':getCurrentPage()!= true}">
                <div>
                    (
                    <span class="value" id="lbCurrentPage1">{{currentPage1}}</span>-
                    <span class="value" id="lbTotalPages1">{{totalPageNm1}}</span>)
                    <span>OF {{rowCount1}}</span>
                </div>
                <img src="assets/images/Icon metro-next.svg" (click)="goToNexpage()" class="text-primary nextPage"
                    [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}">
                <img src="assets/images/Icon awesome-fast-forward.svg" width="10" (click)="goToLastPage()"
                    class="text-primary lastPage" [ngClass]="{'disable_icon':isLastPage()== true,'enable_icon':isLastPage()!= true}">
            </div>

        </div>
    </div>
    
    <button mat-button mat-dialog-close (click)="onNoClick()" class="close black-button">X</button>
</div>